
import { createStore } from 'vuex';
// import Vuex from "vuex";
const store = createStore({
  state () {
    return {
      count: 0,
      address: false,
      desclimberAgree: false,
      profileImage: ''
    }
  },
  mutations: {
    addaddess(state:any,active){
    state.address = active
    },
    increment (state: any,n) {
      state.count = n
    },
    desclimber (state: any,n) {
      state.desclimberAgree = n
    }
  }
})

export default store;